import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';
import List from './components/List';

const CheckLeak = () => {
  const { leakDetector } = usePermission();

  if (!leakDetector.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Kiểm tra rò rỉ' }, { name: 'Dữ liệu kiểm tra' }]}
        />
      </div>
      <List />
    </ContainerBody>
  );
};

export default compose(withPaginate)(CheckLeak);
